module.exports = __webpack_public_path__ + "img/alarm-warning-dent-red.ee5e15c6.svg";